// extracted by mini-css-extract-plugin
export default {"ide-content":"ideContent_ide-content__SQ6pj","ide-content__editor":"ideContent_ide-content__editor__RAKDx"};